module.exports = __webpack_public_path__ + "img/marker-near.d758ea47.svg";